module.exports = __webpack_public_path__ + "static/media/duolingo.1912aaad.svg";